import React, { useState } from "react";
import { Form, FormGroup, Input, Label, Modal, ModalBody, ModalHeader } from "reactstrap";
import "../../molecules/BrandModal.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle, faTimes } from "@fortawesome/free-solid-svg-icons";

export const ApproveModal = ({ toggle, setToggle, onSubmit, accountId, account }) => {
  const [shortname, setShortname] = useState("");
  const [showShortnameError, setShowShortnameError] = useState(false);
  const [shortnameError, setShortnameError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const close = () => {
    setToggle(false);
    setShortname("");
    setShowShortnameError(false);
    setShortnameError("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!shortname.trim()) {
      setShortnameError("Required");
      setShowShortnameError(true);
      return;
    }
    if (shortname.trim().length > 30) {
      setShortnameError("Short name must not exceed 30 characters.");
      setShowShortnameError(true);
      return;
    }
    setSubmitting(true);
    try {
      const result = await onSubmit(accountId, shortname);
      if (result !== null) {
        setShortnameError(result);
        setShowShortnameError(true);
        return;
      }
      close();
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Modal isOpen={toggle} toggle={close} className="brand-modal">
      <ModalHeader toggle={close}>Approve Account</ModalHeader>
      <ModalBody>
        <p className="brand-modal__desc">
          Are you sure you want to approve{" "}
          <strong>{account?.name || "this request"}</strong>? This will send the account to MDM.
        </p>
        <Form onSubmit={handleSubmit}>
          <FormGroup>
            <Label for="shortnameId">Short name</Label>
            <Input
              type="text"
              name="shortnameId"
              id="shortnameId"
              placeholder="Short name"
              onChange={(e) => {
                setShortname(e.target.value);
                if (e.target.value.trim()) setShowShortnameError(false);
              }}
              value={shortname}
            />
            {showShortnameError && <p className="text-danger">{shortnameError}</p>}
          </FormGroup>
          <div className="brand-modal__actions">
            <button type="submit" className="brand-modal__btn brand-modal__btn--primary" disabled={submitting}>
              <FontAwesomeIcon icon={faCheckCircle} /> {submitting ? "Approving…" : "Approve"}
            </button>
            <button type="button" className="brand-modal__btn brand-modal__btn--cancel" onClick={close} disabled={submitting}>
              <FontAwesomeIcon icon={faTimes} /> Cancel
            </button>
          </div>
        </Form>
      </ModalBody>
    </Modal>
  );
};
